import { render, staticRenderFns } from "./mini-backpack.vue?vue&type=template&id=d70a7f1a&scoped=true&"
import script from "./mini-backpack.vue?vue&type=script&lang=js&"
export * from "./mini-backpack.vue?vue&type=script&lang=js&"
import style0 from "./mini-backpack.vue?vue&type=style&index=0&id=d70a7f1a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70a7f1a",
  null
  
)

export default component.exports